import { render } from "./HomTiposBlocosView.vue?vue&type=template&id=c09161d8&scoped=true"
import script from "./HomTiposBlocosView.vue?vue&type=script&lang=js"
export * from "./HomTiposBlocosView.vue?vue&type=script&lang=js"

import "./HomTiposBlocosView.vue?vue&type=style&index=0&id=c09161d8&scoped=true&lang=css"

import exportComponent from "C:\\SGCAD24\\Desenvolvimento\\Corofergs\\FrontBack\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c09161d8"]])

export default __exports__